import './FullFooterStyle.less';

import * as React from 'react';

interface IProps {
  topBorder?: boolean;
}

const PhoenixLegal = () => {
  if (typeof window !== 'undefined' && (window as any).showPhxTest) {
    return (
      <section className="test-phx phx-legal less-padding">
        <div className="col-xs-12 text-x-small">
          <p>
            1 in 3 Sellers: Based on analysis of people who request an offer from Opendoor within 60
            days of listing their home, May-October 2017.
          </p>
          <p>#1 Home Buyer: Based on volume of homes purchased in the Phoenix metro area.</p>
          <p>
            Top Rated Experience: Based on Net Promoter Score of customers who sold their home to
            Opendoor, Dec 2016 - October 2017.
          </p>
        </div>
      </section>
    );
  }

  return <span />;
};

export default class FullFooter extends React.Component<IProps> {
  public static defaultProps: Partial<IProps> = {
    topBorder: true,
  };

  public boundForceUpdate = () => {
    this.forceUpdate();
  };

  public componentDidMount() {
    (window as any).optimizelyCallbacks = (window as any).optimizelyCallbacks || [];
    (window as any).optimizelyCallbacks.push(this.boundForceUpdate);
  }

  public componentWillUnmount() {
    (window as any).optimizelyCallbacks = (window as any).optimizelyCallbacks || [];
    const indexOf = (window as any).optimizelyCallbacks.indexOf(this.boundForceUpdate);
    if (indexOf !== -1) {
      (window as any).optimizelyCallbacks.splice(indexOf, 1);
    }
  }

  public render() {
    const { topBorder } = this.props;

    return (
      <div className="od-full-footer market-footer">
        <div
          className={
            (topBorder === true ? 'top-border' : '') + ' regular-container footer-container'
          }
        >
          <div className="row footer-top">
            <div className="col-xs-12 col-md-3">
              <div>
                <a href="/">
                  <img
                    src="https://images.opendoor.com/source/s3/imgdrop-production/logo-opendoor.svg?service=consumer"
                    alt="Opendoor"
                    height={25}
                    className="opendoor-logo"
                  />
                </a>
                <p className="text-small text-muted hidden-sm-down">© {new Date().getFullYear()}</p>
                <div className="app-links">
                  <p>Get the app</p>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en"
                    target="_blank"
                  >
                    <img src="https://images.opendoor.com/source/s3/imgdrop-production/android-logo.svg?service=consumer" height={12} />
                    <span>Download for Android</span>
                  </a>
                  <a
                    href="https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8"
                    target="_blank"
                  >
                    <img src="https://images.opendoor.com/source/s3/imgdrop-production/apple-logo.svg?service=consumer" height={12} />
                    <span>Download for iOS</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-9">
              <div className="row">
                <div className="col-xs-12 col-sm-3">
                  <h6 className="text-medium medium-margin-bottom">Services</h6>
                  <ul className="sitemap">
                    <li>
                      <a href="/">Sell your home</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/homes">Buy a home</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/trade-in">Trade-in</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/how-it-works">How it works</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/home-value">Home value</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/trusted-lenders">Lenders</a>
                    </li>
                  </ul>
                </div>
                <div className="col-sm-3 hidden-xs-down">
                  <h6 className="text-medium medium-margin-bottom">About</h6>
                  <ul className="sitemap">
                    <li>
                      <a href="https://www.opendoor.com/w/about">About</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/contact-us">Contact us</a>
                    </li>
                    <li>
                      <a href="/jobs">Jobs</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/faq">FAQ</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/press">Press</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/blog">Blog</a>
                    </li>
                  </ul>
                </div>
                <div className="col-xs-12 col-sm-3 hidden-xs-down">
                  <h6 className="text-medium medium-margin-bottom">Customers</h6>
                  <ul className="sitemap">
                    <li>
                      <a href="/">For home sellers</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/homes">For home buyers</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/agents">For real estate agents</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/reviews">Reviews</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/stories">Stories</a>
                    </li>
                    <li>
                      <a href="https://www.opendoor.com/w/resources">Resources</a>
                    </li>
                  </ul>
                </div>
                <div className="col-xs-12 col-sm-3">
                  <h6 className="text-medium medium-margin-bottom">Terms & privacy</h6>
                  <ul className="sitemap">
                    <li>
                      <a href="/safety">Trust &amp; safety</a>
                    </li>
                    <li>
                      <a href="/w/terms">Terms of service</a>
                    </li>
                    <li>
                      <a href="/w/privacy">Privacy policy</a>
                    </li>
                    <li>
                      <a href="/privacyrequest">Do not sell my info</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row footer-bottom">
            <div className="col-xs-12 col-md-3">
              <img
                src="https://images.opendoor.com/source/s3/imgdrop-production/3c3b55d2bafb409fa42c8b33fd43c9d2.png?service=consumer"
                alt="Equal housing opportunity"
                height={45}
              />
            </div>
            <div className="col-xs-12 col-md-5 text-product-medium" />
            <div className="col-xs-12 col-md-1 hidden-sm-down" />
            <div className="col-xs-12 col-md-3 social-links">
              <a href="https://www.facebook.com/OpendoorHQ" target="_blank" className="social-link">
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/facebook-icon.svg?service=consumer"
                  alt="Opendoor on Facebook"
                  width={20}
                />
              </a>
              <a href="https://twitter.com/Opendoor" target="_blank" className="social-link">
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/twitter-icon.svg?service=consumer"
                  alt="Opendoor on Twitter"
                  width={20}
                />
              </a>
              <a
                href="https://www.linkedin.com/company/opendoor-com"
                target="_blank"
                className="social-link"
              >
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/linkedin-icon.svg?service=consumer"
                  alt="Opendoor on LinkedIn"
                  width={20}
                />
              </a>
              <a href="https://www.instagram.com/opendoor/" target="_blank" className="social-link">
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/instagram-icon.svg?service=consumer"
                  alt="Opendoor on Instagram"
                  width={20}
                />
              </a>
              <a
                href="https://www.pinterest.com/opendoorhq/"
                target="_blank"
                className="social-link"
              >
                <img
                  src="https://images.opendoor.com/source/s3/imgdrop-production/pinterest-icon.svg?service=consumer"
                  alt="Opendoor on Pinterest"
                  width={20}
                />
              </a>
            </div>
          </div>
        </div>
        <PhoenixLegal />
      </div>
    );
  }
}
